import {
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';

export const contractTemplateInitialValues: IContractTemplateTreeItemForm[] = [
  {
    id: '0',
    type: TEMPLATE_TYPE.contract,
    content: '',
    disabledCollapse: true,
    disabledSelection: true,
    disabledRemove: true,
    autoFocus: true,
    children: [],
  },
];
